
export const UPLOAD_FILE = '/api/admin/uploadFile/add';
export const TEXT2MP3 = '/api/admin/uploadFile/text2Mp3';

export const LOGIN = '/api/admin/admin/login';

export const GET_USER_BY_TOKEN = '/api/admin/admin/getUserByToken';
export const GET_MENU_DATA = '/api/admin/admin/getMenuData';
export const GET_HOME_DATA = '/api/admin/home/getHomeData';
export const ADMIN_LIST = '/api/admin/admin/getList';

//文章管理

export const RESOURCES_EDIT = '/api/admin/staticResources/edit';
export const RESOURCES_LIST = '/api/admin/staticResources/getList';


//园区管理
export const PARK_ADD = '/api/admin/park/add';
export const PARK_EDIT = '/api/admin/park/edit';
export const PARK_DEL = '/api/admin/park/del';
export const PARK_LIST = '/api/admin/park/getList';
export const PARK_GET_BYID = '/api/admin/park/getById';


//常见问题
export const FAQ_ADD = '/api/admin/faq/add';
export const FAQ_EDIT = '/api/admin/faq/edit';
export const FAQ_DEL = '/api/admin/faq/del';
export const FAQ_LIST = '/api/admin/faq/getList';

//首页banner
export const HOME_BANNER_ADD = '/api/admin/homeBanner/add';
export const HOME_BANNER_EDIT = '/api/admin/homeBanner/edit';
export const HOME_BANNER_DEL = '/api/admin/homeBanner/del';
export const HOME_BANNER_LIST = '/api/admin/homeBanner/getList';


//文章管理
export const ARTICLE_ADD = '/api/admin/article/add';
export const ARTICLE_EDIT = '/api/admin/article/edit';
export const ARTICLE_DEL = '/api/admin/article/del';
export const ARTICLE_LIST = '/api/admin/article/getList';


//展览管理
export const EXHIBITION_ADD = '/api/admin/exhibition/add';
export const EXHIBITION_EDIT = '/api/admin/exhibition/edit';
export const EXHIBITION_DEL = '/api/admin/exhibition/del';
export const EXHIBITION_LIST = '/api/admin/exhibition/getList';
export const EXHIBITION_GET_BYID = '/api/admin/exhibition/getById';

//闭馆日期管理
export const CLOSE_DATE_ADD = '/api/admin/itineraryPlan/closeDate/add';
// export const CLOSE_DATE_EDIT = '/api/admin/itineraryPlan/closeDate/edit';
export const CLOSE_DATE_DEL = '/api/admin/itineraryPlan/closeDate/del';
export const CLOSE_DATE_LIST = '/api/admin/itineraryPlan/closeDate/getList';

//闭馆日期管理
export const COMMON_DATE_ADD = '/api/admin/itineraryPlan/commonDate/add';
// export const COMMON_DATE_EDIT = '/api/admin/itineraryPlan/commonDate/edit';
export const COMMON_DATE_DEL = '/api/admin/itineraryPlan/commonDate/del';
export const COMMON_DATE_LIST = '/api/admin/itineraryPlan/commonDate/getList';


//兴趣点
export const INTERESTS_ADD = '/api/admin/itineraryPlan/interests/add';
export const INTERESTS_EDIT = '/api/admin/itineraryPlan/interests/edit';
export const INTERESTS_DEL = '/api/admin/itineraryPlan/interests/del';
export const INTERESTS_LIST = '/api/admin/itineraryPlan/interests/getList';



//用户管理
export const USER_LIST = '/api/admin/wechatMiniUsers/getList';
export const USER_MSG_BOARD_LIST = '/api/admin/userMessageBoard/getList';
export const USER_MSG_BOARD_DEL = '/api/admin/userMessageBoard/del';




//trail
export const ROUTES_LIST = '/api/admin/routes/getList';

export const ROUTES_DATA_PLACE_LIST = '/api/admin/routeDakaPlace/getList';
export const ROUTES_DATA_PLACE_EDIT = '/api/admin/routeDakaPlace/addEdit';
export const ROUTES_CHENGJIU_LIST = '/api/admin/routeChengjiu/getList';
export const ROUTES_CHENGJIU_ADD_EDIT = '/api/admin/routeChengjiu/addEdit';

//图片
export const BAIDU_IMG_GROUP_ADD_EDIT = '/api/admin/baiduSearchImg/addEditGroup';
export const BAIDU_IMG_LIST = '/api/admin/baiduSearchImg/getImgList';

export const BAIDU_IMG_GROUP_LIST = '/api/admin/baiduSearchImg/getGroupList';
export const BAIDU_IMG_GROUP_DEL = '/api/admin/baiduSearchImg/delGroup';
export const BAIDU_IMG_ADD = '/api/admin/baiduSearchImg/similarAdd';
export const BAIDU_IMG_DEL = '/api/admin/baiduSearchImg/similarDel';
export const BAIDU_IMG_SEARCH = '/api/admin/baiduSearchImg/similarSearch';


export const ANSWER_TEMPLATE_LIST = '/api/admin/answerTemplate/getList';
export const ANSWER_TEMPLATE_ADD = '/api/admin/answerTemplate/add';
export const ANSWER_TEMPLATE_EDIT = '/api/admin/answerTemplate/edit';
export const ANSWER_TEMPLATE_DEL = '/api/admin/answerTemplate/del';
export const ANSWER_RESULT_LIST = '/api/admin/answerTemplate/getResultList';


export const LOTTERY_LIST = '/api/admin/lottery/lotteryConfig/getList';
export const LOTTERY_ADD = '/api/admin/lottery/lotteryConfig/add';
export const LOTTERY_EDIT = '/api/admin/lottery/lotteryConfig/edit';
export const LOTTERY_DEL = '/api/admin/lottery/lotteryConfig/del';
export const LOTTERY_RESULT_LIST = '/api/admin/lottery/lotteryConfig/getResultList';
export const LOTTERY_RESULT_CHANGE_STATUS = '/api/admin/lottery/lotteryConfig/changeResultStatus';

export const LOTTERY_COUNT_LIST = '/api/admin/lottery/lotteryConfig/getGiftCountList';



// WEBPACK FOOTER //
// ./src/apiUrl.js